/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { IncomeTypeDto, IncomeTypeDtoFromJSON, IncomeTypeDtoFromJSONTyped, IncomeTypeDtoToJSON } from "./IncomeTypeDto";

/**
 *
 * @export
 * @interface DeferredIncomeDto
 */
export interface DeferredIncomeDto {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeDto
   */
  number: number;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeDto
   */
  name: string;
  /**
   *
   * @type {IncomeTypeDto}
   * @memberof DeferredIncomeDto
   */
  incomeType: IncomeTypeDto;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeDto
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeDto
   */
  openAt: Date | null;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeDto
   */
  closedAt: Date | null;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeDto
   */
  frozenAmount: number;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeDto
   */
  status: DeferredIncomeDtoStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export type DeferredIncomeDtoStatusEnum = "NEW" | "PLAN" | "PROCESS" | "CLOSED";

export function DeferredIncomeDtoFromJSON(json: any): DeferredIncomeDto {
  return DeferredIncomeDtoFromJSONTyped(json, false);
}

export function DeferredIncomeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeferredIncomeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    name: json["name"],
    incomeType: IncomeTypeDtoFromJSON(json["incomeType"]),
    createdAt: new Date(json["createdAt"]),
    openAt: json["openAt"] === null ? null : new Date(json["openAt"]),
    closedAt: json["closedAt"] === null ? null : new Date(json["closedAt"]),
    amount: json["amount"],
    frozenAmount: json["frozenAmount"],
    status: json["status"],
  };
}

export function DeferredIncomeDtoToJSON(value?: DeferredIncomeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    name: value.name,
    incomeType: IncomeTypeDtoToJSON(value.incomeType),
    createdAt: value.createdAt.toISOString(),
    openAt: value.openAt === null ? null : value.openAt.toISOString(),
    closedAt: value.closedAt === null ? null : value.closedAt.toISOString(),
    amount: value.amount,
    frozenAmount: value.frozenAmount,
    status: value.status,
  };
}
